import { useEffect, useState } from 'react';

// Keeps the page informed of an editor's dirty state, and clears it when the editor unmounts.
export function useReportDirty(isDirty: boolean, onDirtyChange: (dirty: boolean) => void) {
    useEffect(() => { onDirtyChange(isDirty); }, [isDirty, onDirtyChange]);
    useEffect(() => () => onDirtyChange(false), [onDirtyChange]);
}

// Holds back a navigation action while there are unsaved edits, until the user confirms the discard.
export function useUnsavedChangesGuard(isDirty: boolean) {
    const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);

    const run = (action: () => void) => {
        if (isDirty) setPendingAction(() => action);
        else action();
    };

    const confirm = () => {
        const action = pendingAction;
        setPendingAction(null);
        action?.();
    };

    const cancel = () => setPendingAction(null);

    return { run, isPending: pendingAction !== null, confirm, cancel };
}
